<template>
  <div class="main_container">
    <div class="head_alarm">
      <button v-show="false" @click="opendis">打开测距</button>
      <span @click="$router.go(-1)" class="head_left" v-if="!hideBackBtn">返回</span>
      {{alarmInfo.Name | name_f}} 
      <!-- <span @click="$router.push({name:'deal', params:{id: $route.params.id}})" class="head_right">处理</span> -->
      <!-- <span @click="$router.push({name:'createTaskWithAlarm', params:{alarm_id: $route.params.id}})" class="head_right">生成任务</span> -->
    </div>
    <div>
      <div class="map" id="allmap" style="position: relative;">
    </div>
    <van-popup style="background: #22394a;width: 250px;padding: 10px;border-radius: 12px;position: absolute;top: 127px" v-model="showInfoWindow" :overlay="false">
      <div style="position: relative;">
        <div style="color:white;margin-bottom:10px">{{station.Name}}
          <img @click="showInfoWindow=false" src="static/icon/close.png" style="float:right;height:23px">
        </div>
        <div>
          <div class="tb_label">COD:</div><div class="tb_value" :style="{background:getPMInfo(station.pm25, 'pm25').bgcolor}">{{station.cod}}</div>
          <div class="tb_label">氨氮:</div><div class="tb_value" :style="{background:getPMInfo(station.pm10, 'pm10').bgcolor}">{{station.ammonia_nitrogen}}</div>
        </div>
        <div v-show="station.turbidity || station.temperature">
          <div class="tb_label">浊度:</div><div class="tb_value">{{station.turbidity}}</div>
          <div class="tb_label">水温:</div><div class="tb_value">{{station.temperature}}</div>
        </div>
        
        <div v-show="station.conductivity || station.dissolved_oxygen">
          <div class="tb_label">电导率:</div><div class="tb_value">{{station.conductivity}}</div>
          <div class="tb_label">溶解氧:</div><div class="tb_value">{{station.dissolved_oxygen}}</div>
        </div>
        <div v-show="station.ph">
          <div class="tb_label">PH:</div><div class="tb_value">{{station.ph}}</div>
        </div>
        <div>
          <div class="tb_label">时间:</div><div class="tb_value" style="border:none">{{moment((station.time-3600*8)*1000).format('YYYY-MM-DD HH:mm:ss')}}</div>
        </div>
        <div>
          <div class="tb_label">查看:</div><div class="tb_value" style="border:none"><a @click="clickRow(station)">详细数据</a></div>
        </div>
      </div>
    </van-popup>
    </div>


    <div style="text-align: center;margin-top: 6px" class="water">
      <!-- <el-radio-group size="small" v-model="timep">
        <el-radio-button label="min">实时</el-radio-button>
        <el-radio-button label="hour">时均</el-radio-button>
        <el-radio-button label="day">日均</el-radio-button>
      </el-radio-group> -->
      <el-radio-group size="mini" v-model="tp">
        <el-radio-button v-for="item in waterTypes" :label="item.value" :key="item.value">{{item.label}}</el-radio-button>
        <!-- <el-radio-button label="ammonia_nitrogen">氨氮</el-radio-button> -->
      </el-radio-group>
    </div>
    <!-- <div style="margin: 5px auto; text-align: center">
      <span style="margin: 0 0 0 10px; font-size: 14px;">对比:</span>
      <el-select size="mini" v-model="back" placeholder="请选择" style="width: 130px">
        <el-option
          v-for="item in selectBack"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div> -->

    <div style="width: 100%"><div style="margin: 5px auto; text-align: center; font-size: 14px;">报警类型：{{alarmInfo.type_name}}</div></div>

    <div style="height: 240px;margin-top: 10px">
      <div style="height: 240px" class="chart" :id="id" :option="option_alarm"></div>  
    </div>

    <!-- <div class="ui horizontal divider">
      处理任务
    </div>
    <div class="ui feed" style="max-width: 90%;margin: 0 auto 20px auto">
      <div class="event" v-for="task in tasks" @click="$router.push({name:'taskDetail',params:{task_id:task.task_id}})">
        <div class="content" style="border-bottom:1px solid #dcdcdc">
          <div class="summary">
            <a>{{task.title}}</a>
            <div class="date">
              {{task.create_time}}
            </div>
          </div>
        </div>
      </div>
    </div> -->

    

  </div>
</template>

<script>
import HighCharts from 'highcharts'
var _ = require('lodash');
import axios from 'axios'
import moment from 'moment'
import {option_alarm, waterTypes} from '../../../option/option.js'
import massFeatures from '../../../option/pointOverlays'
import { ImagePreview,Dialog,Toast  } from 'vant';
import { mapState } from 'vuex'
function valueFormat(v){
  if (v){
    if (v>100){
      v = parseInt(v)
    }else{
      v = parseInt(v*10)/10
    }
  }
  return v
}


let typeDict = {}
for(let item of waterTypes) {
  typeDict[item.value] = item.label
}

export default {
  name: 'HelloWorld',
  data () {
    return {
      waterTypes,
      msg: 'Welcome to Your Vue.js App',
      id:'test',
      map:'',
      station:{},
      showInfoWindow:false,
      option_alarm,
      timep:'min',
      tp:'cod',  
      selectBack: [
        {value: 'city',label: '城市均值'},
        {value: 'near1',label: '最近1公里'},
        {value: 'near3',label: '最近3公里'},
        {value: 'near5',label: '最近5公里'},
      ],
      typeDict:typeDict,
      back:'city',
      anotherData:[],
      gfInfo:'',
      chart:'',
      typeIdx:{cod:13,ammonia_nitrogen:14,turbidity:15,temperature:16,conductivity:17,dissolved_oxygen:18,ph:19},
      timdDict:{min: '1m', hour: '1h', day: '1d'},
      anotherColor:'rgba(2, 2, 2, 0.48)',
      alarmInfo:'',
      start_t:'',
      end_t:'',
      snData:'',
      round:3000,
      aroundPoints:[],
      alarm_time:'',
      alamSnData:'',
      cirSize:14,
      historyData:'',
      origin_anotherData:'',
      canvasLayer:'',
      myDis:'',
      logs:[],
      tasks:[]
    }
  },
  mounted(){
    this.initMap()
    this.getAlarmLogs()
    this.throttle_getAroundSnData=_.throttle(this.getAroundSnData, 400)
    this.massFeatures = massFeatures()
  },
  filters:{
    name_f(v){
      if(v){
        if(v.length > 10){
          return v.slice(0,10) + '...'
        }else{
          return v
        }
      }else{
        return v
      }
    }
  },
  computed: {
    ...mapState(['hideBackBtn'])
  },
  watch:{
    back(){
      // this.changeBack()
    },
    tp(){
      this.drawMap()
      this.getHistoryData()
      // this.changeBack()
    },
    round(){
      this.getAroundPoints()
    }
  },
  methods:{
    moment,
    // getPMInfo,
    initMap(){
      var map = new BMapLite.Map("allmap");    // 创建Map实例
      
      // 初始化地图,设置中心点坐标和地图级别
      // map.centerAndZoom('日照', 13);
      // var top_left_navigation = new BMap.NavigationControl();  //左上角，添加默认缩放平移控件
      // map.addControl(top_left_navigation);
      // map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      // var myDis = new BMapLib.DistanceTool(map);
      // this.myDis = myDis
      var zoomCtrl = new BMapLite.ZoomControl({anchor: BMAP_ANCHOR_TOP_LEFT, offset: new BMapLite.Size(10, 45)});
      map.addControl(zoomCtrl);
      map.enablePinchToZoom()
      this.map = map
      this.getDetailAlarmInfo()
    },
    clickRow(station){
      var param = station.DevSN + ':' + station.Lng + ':' + station.Lat
      this.$router.push({name:'detailData',params:{id:param}})
      
    },
    opendis(){
      this.myDis.open()
    },
    changeBack(){
      if (this.back == 'near_gf'){
        this.getNearGfData() 
        this.round = 0
      }
      if (this.back == 'gf_avg'){
        this.getGfavg()
        this.round = 0
      }
      if (this.back == 'near1'){
        this.getNearStationAvg(1000)
        this.round = 1000
      }
      if (this.back == 'near3'){
        this.getNearStationAvg(3000)
        this.round = 3000
      }
      if (this.back == 'near5'){
        this.getNearStationAvg(5000) 
        this.round = 5000
      }
      if (this.back == 'city'){
        this.getCityData()
        this.round = 0
      }
    },
    addAnotherSeries(){
      if(this.chart.series){
        if (this.chart.series.length == 2){
          this.chart.series[1].remove(true);  
        }
        this.chart.addSeries(this.anotherData)
      }
    },
    getNearStationAvg(dist=1000){
      var self = this
      var url = "yc2/getNearStationAvg?lng="+this.alarmInfo.Lng+"&lat="+this.alarmInfo.Lat+"&sn="+this.alarmInfo.DevSN+"&round="+dist+"&timep="+this.timep
      url += '&start_t=' + this.start_t + '&end_t='+this.end_t
      this.axios_base.get(url).then(function(resp){
        self.origin_anotherData = resp.data
        self.drawNear(dist)
      }).catch(function(e){
        console.log(e)
        self.anotherData = {name:'最近'+dist/1000+'km均值', data:[], color:'rgba(2, 2, 2, 0.48)',zIndex: 1}
        self.addAnotherSeries()
      })
    },
    drawNear(dist){
      var data = this.origin_anotherData.data
      var seriesData = []
      for (var i in data){
        var v = data[i][this.tp]
        v = valueFormat(v)
        seriesData.push([data[i].time, v])
      }
      this.anotherData = {name:'最近'+dist/1000+'km均值(' +this.origin_anotherData.sninfo.length + ')', data:seriesData, color:'rgba(2, 2, 2, 0.48)',zIndex: 1}
      this.addAnotherSeries()
    },
    getDetailAlarmInfo(){
      var self = this
      this.axios_base.get('alarm/getAlarmDetailInfo?alarm_id='+this.$route.params.id).then(function(resp){
        self.alarmInfo = resp.data[0]
        const alarmtype = self.alarmInfo.alarm_type
        self.tp = self.alarmInfo.alarm_type.slice(0, alarmtype.length - 5)
        self.alarm_time = self.alarmInfo.start_time
        self.start_t = self.alarmInfo.start_timestamp-3600 * 24 * 7
        if(self.alarmInfo.end_timestamp){
          self.end_t = self.alarmInfo.end_timestamp+3600  
        }else{
          self.end_t = Date.parse(new Date())/1000
        }
        
        if ((self.end_t - self.start_t) > 24*3600){
          self.timep = 'hour'
        }
        if ((self.end_t - self.start_t) > 24*3600*10){
          self.timep = 'day'
        }
        self.map.centerAndZoom(new BMapLite.Point(self.alarmInfo.Lng,self.alarmInfo.Lat), 13);
        // self.getAroundPoints()
        self.getHistoryData()
        self.getTaskByAlarm()
      })
    },
    getAroundPoints(){
      var self = this
      this.axios_base.get("alarm/GetNearStation?sn=" + this.alarmInfo.DevSN+ "&lng=" +this.alarmInfo.Lng +"&lat="+this.alarmInfo.Lat + "&round="+this.round).then(function(resp){
        self.aroundPoints = resp.data
        self.aroundPoints.push({DevSN:self.alarmInfo.DevSN})
        self.getAroundSnData()
      })
    },
    getAroundSnData(){
      var self = this
      var snList = _.map(this.aroundPoints, 'DevSN')
      snList.push(this.alarmInfo.DevSN)
      var sn_str = _.join(snList,'|')
      this.axios_base.get("alarm/getAroundSnData?sn_str="+ sn_str+ "&t="+ this.alarm_time+ "&timep="+this.timep).then(function(resp){
        var data = resp.data
        for (var i in data){
          for(var j in self.aroundPoints){
            if (data[i].sn == self.aroundPoints[j].DevSN){
              self.aroundPoints[j].pm25 = valueFormat(data[i].pm25) 
              self.aroundPoints[j].pm10 = valueFormat(data[i].pm10)
              self.aroundPoints[j].time = data[i].time
            }
            if (self.aroundPoints[j].DevSN == self.alarmInfo.DevSN){
              self.aroundPoints[j].Lng = self.alarmInfo.Lng
              self.aroundPoints[j].Lat = self.alarmInfo.Lat
              self.aroundPoints[j].Name = self.alarmInfo.Name
            }
          }
        }
        self.drawMap()
      })
    },
    drawCir(){
      var p = new BMapLite.Point(this.alarmInfo.Lng,this.alarmInfo.Lat)
      this.map.panTo(p)
      let overlay = new this.massFeatures(p, 15, "red", this.alarmInfo)
      this.map.addOverlay(overlay);
      
      // cir.setCenter(p)
      // cir.setRadius(this.round)
      // cir.setStrokeColor('red')
      // cir.setStrokeWeight(2)
      // cir.setFillOpacity(0.1)
      // this.map.addOverlay(cir)
    },
    drawMap(){
      var self = this
      this.map.clearOverlays()
      this.drawCir()
      var opts = {                  
            width : 200,     // 信息窗口宽度
            height: 180,     // 信息窗口高度
            title:'', 
          }
      for (var i in this.aroundPoints){
        var p_info = this.aroundPoints[i]
        var lng = p_info.Lng
        var lat = p_info.Lat
        var sn = p_info.DevSN
        var border = ""
        var p = new BMapLite.Point(lng,lat)
        if (sn == this.alarmInfo.DevSN){
          var lng = self.alarmInfo.Lng
          var lat = self.alarmInfo.Lat
          var p = new BMapLite.Point(lng,lat)
          setTimeout(self.map.panTo(p), 500)
          border = "border:3px solid black;"
        }
        if (this.tp == 'pm25'){
          var val = p_info.pm25
          var rs = getPMInfo(val,'pm25')
          var color = rs.bgcolor
          var font_color = rs.fgcolor
        }else{
          var val = p_info.pm10
          var rs = getPMInfo(val,'pm10')
          var color = rs.bgcolor
          var font_color = rs.fgcolor
        }
        if (!val){
          val = '--'
          continue
        }else{
          val = parseInt(val)
        }
        var htm = `<div class="cir" style="position:absolute;transform:translate(-50%,-50%);color:`+font_color+`;border-radius: 50%;width: `+this.cirSize*2+`px; height: `+this.cirSize*2+`px;line-height: `+this.cirSize*2+`px;font-size: 14px;text-align: center;`+border+`background:`+color+`"><span>`+val+`</span></div>`
        var marker = new BMapLib.Marker(htm, p);
        marker.info = p_info
        this.map.addOverlay(marker)
        marker.addEventListener('click',function(e){
          var info = e.currentTarget.info
          self.showInfoWindow = true
          self.station = info
          var lng = info.Lng
          var lat = info.Lat
          var pts = new BMapLite.Point(lng,lat)
          self.map.panTo(pts)
          // var t = moment((info.time-3600*8)*1000).format('YYYY-MM-DD HH:mm:ss');
          // var content =  ` 
          //  <div style="margin:0;line-height:11px;padding:2px;">                 
          //    <p>名称:${info.Name}</p>   
          //    <p>时间:${t}</p>  
          //    <p>PM2.5:${info.pm25}</p> 
          //    <p>PM10:${info.pm10}</p> 
          //    <p>SN:${info.DevSN}</p>`
          // var infoWindow = new BMap.InfoWindow(content,opts)
          // self.map.openInfoWindow(infoWindow,pts)
        })
      }
    },
    getHistoryData:function(){
      var self = this;
      var t = this.timdDict[this.timep]
      if (this.historyData){
        this.drawHistory()
        return
      }

      const start = moment(this.start_t * 1000).format("YYYY-MM-DD HH:mm:ss")
      const end = moment(this.end_t * 1000).format("YYYY-MM-DD HH:mm:ss")
      let url = `wz/getStationDataTimeSlot?time_type=${this.timep}&station_id=${this.alarmInfo.ID}&start_time=${start}&end_time=${end}&alltype=1&air_type=1`
      // var url = "yc2/getStationHistory?timetype="+t+"&station_id="+this.alarmInfo.ID+"&startTime="+this.start_t+"&endTime="+this.end_t+"&sensortypes=cod,ammonia_nitrogen,turbidity,temperature,conductivity,dissolved_oxygen,ph"
      this.axios_base.get(url).then(function(resp){
        self.historyData = resp.data.values
        self.drawHistory()
      })
    },
    drawHistory(){
      var data = this.historyData
      var self= this
      var type_name = this.typeDict[this.tp]
      var seriesData = []
      for (var i in data){
        var v = data[i][self.typeIdx[self.tp]]
        v = valueFormat(v)
        seriesData.push([(data[i][0] + 3600*8)*1000, v])  
      }
      self.snData = {name: self.alarmInfo['Name'] + '-' + type_name,data: seriesData,color:'#7CB5EC', zIndex:2}
      self.option_alarm.series = [self.snData]

      self.option_alarm.xAxis.plotLines = [{
        color:'red',
        dashStyle:'solid',
        value:(self.alarmInfo.start_timestamp+8*3600)*1000,    
        width:2,
        id:'plot1'           
      },{
        color:'red',
        dashStyle:'solid',
        value:(self.alarmInfo.end_timestamp+8*3600)*1000,    
        width:2,
        id:'plot11'           
      }]

      // 点击图表事件
      // self.option_alarm.chart= {
      //   events: {
      //     click: function(event) {
      //       var t = event.xAxis[0].axis.chart.hoverPoint.x
      //       self.clickChart(t)
      //     }
      //   }
      // }
      // // 点击曲线事件
      // self.option_alarm.plotoption_alarms={ 
      //   series: { 
      //     cursor: 'pointer', 
      //     events: { 
      //       click: function(e) { 
      //         var t = e.point.x
      //         self.clickChart(t)
      //       } 
      //     } 
      //   } 
      // }

      // tooltips事件
      self.option_alarm.tooltip = {
        formatter: this.toolFunc
      }
    
      self.chart = HighCharts.chart(self.id,self.option_alarm);
      // self.changeBack()
    },
    clickChart(t){
      this.chart.update({
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%m-%d',
              week: '%m-%d',
              month: '%Y-%m',
              year: '%Y'
          },
          plotLines:[
          {
            color:'red',
            dashStyle:'solid',
            value:(this.alarmInfo.start_timestamp+8*3600)*1000,    
            width:2,
            id:'plot1'           
          },{
            color:'black',
            dashStyle:'solid',
            value:t,    
            width:2,
            id:'plot2',
            events:{
              mousemove: function(e){
                alert('movae')
              }
            }           
          }]
        }
      })
      this.alarm_time = moment(t-3600*8*1000).format('YYYY-MM-DD HH:mm:ss');
      this.getAroundSnData()
    },
    toolFunc(e){
      var self = this
      var t = e.chart.hoverPoint.options.x
      this.chart.xAxis[0].removePlotLine('plot2'); 
      this.chart.xAxis[0].addPlotLine({
        color:'black',
        dashStyle:'solid',
        value:t,    
        width:2,
        id:'plot2'
      })
      this.alarm_time = moment(t-3600*8*1000).format('YYYY-MM-DD HH:mm:ss');

      var series = this.chart.series
      var idx = e.chart.hoverPoint.index
      const y1 = series[0].data[idx] ? parseInt(series[0].data[idx].y) : "--"
      const y2 = series[1].data[idx] ?parseInt(series[1].data[idx].y) : "--"
      var s = `<p>时间：${this.alarm_time}</p><br><p>${series[0].name}：${y1}</p><br><p>${series[1].name}：${(y2)}</p>`
      // this.getAroundSnData()
     this.throttle_getAroundSnData()
      return s;
    },
    getCityData(){
      if (this.cityData){
        this.drawCity()
        return 
      }
      var self = this
      var t = this.timdDict[this.timep]
      // const start = moment(this.start_t * 1000).format("YYYY-MM-DD HH:mm:ss")
      // const end = moment(this.end_t * 1000).format("YYYY-MM-DD HH:mm:ss")
      // let url = `wz/getStationDataTimeSlot?time_type=${this.timep}&station_id=${this.alarmInfo.ID}&start_time=${start}&end_time=${end}&alltype=1&air_type=1`
      var url = "/yc2/getStationHistory?timetype="+t+"&station_sn=FFFF-FF29&startTime="+this.start_t+"&endTime="+this.end_t+"&sensortypes=cod,ammonia_nitrogen,turbidity,temperature,conductivity,dissolved_oxygen,ph"
      this.axios_base.get(url).then(function(resp){
        var data = resp.data.datas
        self.cityData = data
        self.drawCity()
      })
    },
    drawCity(){
      var data = this.cityData
      var seriesData = []
      for(var i in data){
        var v = data[i][this.typeIdx[this.tp]]
        v = valueFormat(v)
        seriesData.push([(data[i][0] + 3600*8)*1000, v])
      }
      this.anotherData = {name:'城市均值', data:seriesData,color:this.anotherColor}
      this.addAnotherSeries()
    },
    getAlarmLogs(){
      var self = this;
      this.axios_base.get('alarm/getAlarmLogs?task_id=' + this.$route.params.id).then(function(resp){
        self.logs = resp.data
      })
    },
    confirmDelete(log){
      var self = this
      Dialog.confirm({
        title: '确定删除记录?',
        // message: '弹窗内容'
      }).then(() => {
        self.axios_base.get('alarm/deleteLog?log_id='+log.id).then(function(resp){
          self.getAlarmLogs()
        })
      }).catch(() => {
        console.log('cancel')
      });
    },
    getTaskByAlarm(){
      var self = this
      this.axios_base.get('session/getTaskByAlarm?alarm_id='+this.$route.params.id).then(function(resp){
        self.tasks = resp.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map{
  width: 100%;
  height: 300px
}
</style>
<style>
  .water .el-radio-button--mini .el-radio-button__inner {
    padding: 6px 10px !important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/application/alarm/alarmDetail.vue